import React, {useEffect} from 'react';
import Header from '../../partials/Header';
import PageIllustration from '../../partials/PageIllustration';
import PageIllustration2 from '../../partials/PageIllustration2';
import BlogSingleERP from '../../partials/BlogSingleERP';
import Footer from '../../partials/Footer';

function BlogPostERP() {

  useEffect(() => {
    document.title = `Connecter son ERP à OpenCash : quelles solutions choisir pour une intégration fluide et sécurisée ? | CPI Software`
  }, [])
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="grow">
        <div className="relative max-w-6xl mx-auto h-0 pointer-events-none -z-1" aria-hidden="true">
          <PageIllustration />
          <PageIllustration2 />
        </div>
        {/*  Page sections */}
        <BlogSingleERP />
      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default BlogPostERP;